export const getDescriptionData = (data, /*category, */subcategory) => {
  //const categoryData = data.subcategories.find(cat => cat.name === category);
  if (!subcategory) return null;

  //const findSubcategory = (items) => {
    //for (const item of items) {
      //if (item.name === subcategory) return item;
      //if (item.subcategories) {
        //const found = findSubcategory(item.subcategories);
        //if (found) return found;
      //}
    //}
      //return {subcategories:[]};
  //};

  //console.log('getDescriptionData:subcategory', subcategory)
  //console.log('getDescriptionData:findSubcategory:', findSubcategory(data.subcategories))
  ////return findSubcategory(categoryData.subcategories);
  //return findSubcategory(data.subcategories);
  return {
      title: subcategory.name,
      description: subcategory.description
  }
};

export const getSubcategoryData = (data, /*category, */subcategory) => {
  //console.log('getSubcategoryData:category', category)
  //console.log('getSubcategoryData:subcategory', subcategory, data)
  //const categoryData = data.subcategories.find(cat => cat.name === category);
  //if (!categoryData) return null;

  //const findSubcategoryData = (items) => {
    //for (const item of items) {
        //if (item.name === subcategory) return item.subcategories || {subcategories:[]};
      //if (item.subcategories) {
        //const found = findSubcategoryData(item.subcategories);
        //if (found) return found;
      //}
    //}
      //return {subcategories:[]};
  //};

  ////return findSubcategoryData(categoryData.subcategories);
  //return findSubcategoryData(data.subcategories);
  return subcategory;
};

export const findDescendantById = (node, targetId) => {
  if (!node.subcategories) {
    return null;
  }
  for (const child of node.subcategories) {
    if (child.id === targetId) {
      return child;
    }
    const found = findDescendantById(child, targetId);
    if (found) {
      return found;
    }
  }
  return null;
};

export const getParentSubcategoryData = (data, subcategory) => {
  //console.log('__:', data, subcategory)

  const findSubcategoryData = (item) => {
    for (const i of item.subcategories) {
        if (i.id === subcategory.id) return item;
      if (i.subcategories) {
        const found = findSubcategoryData(i);
        if (found) return found;
      }
    }
      return null;
  };

    return findSubcategoryData(data);

}

//export const getCategoryData = (data, category) => {
  //const categoryData = data.subcategories.find(cat => cat.name === category.name);
    //console.log('getCategoryData:categoryData', categoryData, categoryData ? 'yes': 'no')
  //return categoryData ? categoryData: {};
//}; 
